import {
  Button,
  ConfirmDialog,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@up2stay/up2promo-ui';
import { MoreHorizontal, Pencil, Trash2 } from 'lucide-react';
import { useState } from 'react';

export type LeadNoteActionLabels = {
  menu: string;
  edit: string;
  delete: string;
  save: string;
  cancel: string;
  edited: string;
  deleteTitle: string;
  deleteDescription: string;
  deleteConfirm: string;
};

/**
 * "…" menu on the viewer's own note: edit inline or delete after a confirm
 * (DEV-569). Rendered outside the row's tap target so menu and dialog clicks
 * do not toggle the row time.
 */
export function LeadNoteActions({
  labels,
  onEdit,
  onDelete,
}: {
  labels: LeadNoteActionLabels;
  onEdit: () => void;
  onDelete: () => Promise<void>;
}) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="size-7 text-muted-foreground"
            aria-label={labels.menu}
          >
            <MoreHorizontal className="size-4" aria-hidden />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={onEdit}>
            <Pencil className="size-4" aria-hidden />
            {labels.edit}
          </DropdownMenuItem>
          <DropdownMenuItem
            className="text-destructive focus:text-destructive"
            onSelect={() => setConfirmOpen(true)}
          >
            <Trash2 className="size-4" aria-hidden />
            {labels.delete}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ConfirmDialog
        open={confirmOpen}
        onOpenChange={setConfirmOpen}
        title={labels.deleteTitle}
        description={labels.deleteDescription}
        confirmLabel={labels.deleteConfirm}
        cancelLabel={labels.cancel}
        destructive
        onConfirm={onDelete}
      />
    </>
  );
}
